import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import rome from 'rome'
import moment from 'moment'
import momentHelper from 'scoreboard/components/moment-helper'
import icon from 'scoreboard/components/icon'
import selects from 'scoreboard/components/selects'
import i18n from 'scoreboard/components/i18n'
import { isV5, isV6 } from 'scoreboard/components/version'

// the number of years before/after the current year to show in the year dropdown
let yearSpread = 10

let romeOptions = {
	time: false,
	horizontalAlignment: 'center'
}
if (isV5()) {
	romeOptions.inputFormat = momentHelper.numericDateFormat // Fixes #58660
}
if (isV6()) {
	romeOptions.inputFormat = 'YYYY-MM-DD' // Fixes #58660
}
// I don't think it's common in many RTL languages to abbreviate days
// of the week to 1 or 2 letters like how it's done in English
// (e.g Mo, Tu, We). If the page is RTL we want to set the weekdayFormat
// option for the romeinstance to 'short' to show more of the day name.
if ($('html').attr('dir') == 'rtl') {
	romeOptions.weekdayFormat = 'short'
}

//view containing our month and year dropdowns
var DropdownView = Backbone.View.extend({

	className: 'calendar-control rd-dates',

	events: {
		// these select boxes are for us and no one else
		'click .month, .year': 'stopPropagation',
		'change .month': '_onChangeMonth',
		'change .year': '_onChangeYear'
	},

	initialize: function(options) {
		this.options = options || {}
		this.moment = this.options && this.options.moment || moment()
	},

	render: function() {
		this.$el.append(`
			<select class="month"></select>
			<select class="year"></select>
		`)
		// render month dropdown
		var month = this.$('select.month')
		var m = moment()
		for (var i=0; i<12; i++) {
			// set the month
			m.month(i)
			// e.g. <option value="0">January</option>
			month.append(new Option(m.format('MMMM'), i))
		}

		// render year dropdown
		var year = this.$('select.year')
		var baseline = moment().year()
		var selectedYear = this.moment.year()
		var startYear = Math.min(selectedYear, baseline-yearSpread)
		var endYear = Math.max(selectedYear, baseline+yearSpread)
		for (var i=startYear; i<endYear; i++) {
			year.append(new Option(i, i))
		}

		month.wrap('<span class="rd-month-wrapper"></span>')
		year.wrap('<span class="rd-year-wrapper"></span>')

		// select the correct values in the dropdown
		this.setMoment(this.moment)

		return this
	},

	_onChangeMonth: function() {
		var month = parseInt(this.$('select.month').val())
		this.moment.month(month)
		this.trigger('change', this.moment)
	},

	_onChangeYear: function() {
		var year = parseInt(this.$('select.year').val())
		this.moment.year(year)
		this.trigger('change', this.moment)
	},

	setMoment: function(m) {
		this.moment = m = moment(m)
		if (m) {
			this.$('select.month').val(m.month())
			// #26182 if selected year value is not yet in the dropdown
			// add it as a new option
			// (for example, when a user has used the left arrow to click back
			// month by month until they are before the defined "startYear")
			let year = m.year()
			if (this.$(`select.year > option[value="${year}"]`).length == 0) {
				let yearOpt = new Option(year, year)
				if (year < moment().year()) {
					this.$('select.year').prepend(yearOpt)
				} else {
					this.$('select.year').append(yearOpt)
				}
			}
			this.$('select.year').val(m.year())
		}
		selects(this.$('select'))
	},

	stopPropagation: function(e) {
		e.stopPropagation()
	}

})

var CalendarControl = Backbone.View.extend({

	initialize: function(options) {
		this.options = _.extend({tooltip: true},options)
		this.moment = this.options && this.options.moment || moment()
	},

	render: function() {
		var options = _.defaults({}, this.options, romeOptions)
		// have to do this because the format passed in is likely iso but
		// we told rome to use a localized inputFormat which doesn't match
		if (this.options && this.options.initialValue) {
			options.initialValue = moment(this.options.initialValue)
		}

		var r = this.rome = rome(this.el, options)

		// if we're not attached to an input box, setup the dropdowns right away
		if (this.$('.rd-container').length) {
			this.setupDropdowns()
		}

		// if the calendar control is attached to an input box, have to wait
		// until rome has actually drawn the calendar
		r.once('show', () => {
			this.setupDropdowns()
			this.trigger('show')
			this.shown = true
		})

		// whenever the user changes the date
		r.on('data', () => this.trigger('change', this.getMoment()))

		// Whenever the tooltip has been hidden
		r.on('hide', () => {
			// Fixes #15972 - Can't emit hide events until it's been displayed to prevent
			// premature validations when date inputs are toggled from hidden->visible
			this.shown && this.trigger('hide')
		})

		return this
	},

	/**
	 * rome doesn't have dropdowns, so let's add them to match our design
	 */
	setupDropdowns: function() {
		const r = this.rome
		this.dropdownView = new DropdownView({ moment: r.getMoment() }).render()
		this.listenTo(this.dropdownView, 'change', function(moment) {
			// change the value in the control
			this.getRome().setValue(moment, true)
			// make sure a change event is triggered.  The API explicitly states
			// setValue doesn't cause a change event to be triggered
			this.trigger('change', moment)
		}.bind(this))
		r.on('data', () => this.updateDropdownView())
		$(r.container).find('.rd-month-label').after(this.dropdownView.el)

		// Setup back/next buttons + table
		// - Add button classes
		// - Insert icons
		// - Append buttons to .rd-dates container
		// - Insert a wrapper for the calendar table
		// - Add tooltip classes to container
		var datesContainer = $(r.container).find('.rd-dates')
		var arrowsWrapper = $('<span class="rd-arrows-wrapper"></span>')
		arrowsWrapper.append(
			$(r.container).find('.rd-back')
				.attr('aria-label', i18n.get('calendarControl.previousPeriod'))
				.addClass('button button-default')
				.append(icon('arrow-back'))
		)
		arrowsWrapper.append(
			$(r.container).find('.rd-next')
				.attr('aria-label', i18n.get('calendarControl.nextPeriod'))
				.addClass('button button-default')
				.append(icon('arrow-forward'))
		)
		arrowsWrapper.appendTo(datesContainer)
		$(r.container).find('.rd-month').append('<div class="rd-days-wrapper">')
		$(r.container).find('.rd-days').appendTo($(r.container).find('.rd-days-wrapper'))
		$(r.container).addClass(this.options.tooltip ? 'tooltip open is-not-visible' : 'no-tooltip')
	},

	/**
	 * It may not be visible if the user tab'd into the input instead of
	 * clicking on it.
	 *
	 * @return {boolean} true if the rome calendar component tooltip is open (visible).
	 */
	isOpen: function() {
		const c = $(this.rome.container)
		// will not be setup until a user physically interacts with it
		const setup = c.hasClass('tooltip')
		// will only be visible if it was clicked on
		const visible = !c.hasClass('is-not-visible')
		return this.options.tooltip && setup && visible
	},

	/**
	 * Must be called anytime the underlying moment value is changed
	 * (by entering a date directly into the input element)
	 */
	updateDropdownView: function(value) {
		if (_.isNil(value)) {
			let date = this.$el.val()
			if (_.isEmpty(date)) {
				value = this.rome.getRefCal()
			} else {
				value = moment(date, momentHelper.numericDateFormat, momentHelper.STRICT)
			}
		}

		// Make sure `value` isn't null. `value` will still return null if this method is
		// called when a user tabs over to the date input when it is empty or deletes
		// its content via the keyboard. Issue #17751
		if (_.invoke(value, 'isValid') || typeof value === 'string') {
			this.dropdownView.setMoment(value)
		}
	},

	/**
	 * Returns the rome instance associated with this control
	 */
	getRome: function() {
		return rome(this.el)
	},

	/**
	 * Returns the current value shown in the calendar control as a moment.
	 */
	getMoment: function() {
		return this.getRome().getMoment()
	},

	/**
	 * Sets the current value shown in the calendar control using a string,
	 * Date or moment.  Doesn't trigger a change event.
	 */
	set: function(moment) {
		this.getRome().setValue(moment)
	},

	/**
	 * Returns just the date portion of a date, suitable for serializing to the
	 * server.
	 */
	getIsoDate: function() {
		return momentHelper.isoDate(this.getMoment())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.rome && this.rome.destroy()
		_.invokeMap([this.dropdownView], 'remove')
	}

})

export default CalendarControl

CalendarControl.__filename__ = 'components/calendar-control.js'
